<template>
    <div class="locatorFilter">
        <button class="locatorFilter__control" v-on:click="display = !display">
            {{display ? 'Zavřít filtr' : 'Zobrazit filtr'}}
        </button>
        <div class="locatorFilter__optionList" v-if="display">
            <div class="checkboxList-item locatorFilter__option" v-for="type in types">
                <label class="checkbox">
                    <input type="checkbox" class="checkbox-native" :id="type.id" :value="type.id"
                           v-model="selectedTypes" v-on:change="handleTypes(type)">
                    <span class="checkbox-control">&nbsp;</span>
                    <span class="checkbox-label">{{type.name}}</span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import map from 'lodash/map';

    export default {
        name: 'LocatorFirmAndCraftsmenFilter',
        data() {
            return {
                display: true,
                allKey: 'all',
                selectedTypes: [],
                types: [
                    {
                        id: 'all',
                        name: 'Vše'
                    },
                    {
                        id: 'woodwork',
                        name: 'Dřevostavby'
                    },
                    {
                        id: 'drywall',
                        name: 'Sádrokarton'
                    }
                ]
            }
        },
        methods: {
            ...mapActions('locator', ['setTypes', 'fetchContacts']),
            handleTypes(type) {
                if (type.id === this.allKey) {
                    if (this.selectedTypes.indexOf(this.allKey) === 0) {
                        this.selectedTypes = map(this.types, item => item.id)
                    } else {
                        this.selectedTypes = [];
                    }
                }
                this.setTypes(this.selectedTypes);
                this.fetchContacts();
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/locator/FirmAndCraftsmenFilter.vue